import React, { FC, useEffect, useMemo } from 'react';

import { useFormikContext } from 'formik';

import AampeSteps from '../../../../../../components/shared/AampeStepper/AampeSteps';
import styled from 'styled-components';

import aampeTheme from '../../../../../../constants/aampeTheme';
import { androidAddButtonElement } from './constants';

import { NotificationButtonFormValues } from '../../../../../../models/formula.model';
import { AampeStepperStepProps } from '../../../../../../models/stepper.model';

import AndroidButtonForm from './AndroidButtonForm';
import IosButtonForm from './IosButtonForm';

interface NotificationButtonFormProps {
    currentIndex: number;
    setCurrentIndex: (val: number) => void;
}
const NotificationButtonForm: FC<NotificationButtonFormProps> = ({
    currentIndex,
    setCurrentIndex,
}) => {
    const { values, setFieldValue } =
        useFormikContext<NotificationButtonFormValues>();
    const steps = useMemo<AampeStepperStepProps[]>(() => {
        const initialSteps: AampeStepperStepProps[] = [
            {
                title: 'iOS buttons',
                hideHeader: true,
                renderComponent: <IosButtonForm />,
                name: '',
                tabKey: 'ios',
            },
            {
                title: 'Android buttons',
                hideActionButtons: true,
                tabKey: 'android',
                renderComponent: <AndroidButtonForm />,
                name: '',
            },
        ];
        return initialSteps;
    }, []);

    const isNextStepClick = useMemo<boolean>(
        () => (values.iosToggle ? !!values.iosNotificationCategory : true),
        [values],
    );

    useEffect(() => {
        if (!values.androidToggle) {
            setFieldValue('androidButtons', [{ ...androidAddButtonElement }]);
        }
        if (!values.iosToggle) {
            setFieldValue('iosNotificationCategory', undefined);
            setFieldValue('iosButtons', []);
        }
    }, [setFieldValue, values.androidToggle, values.iosToggle]);
    return (
        <AampeStepperContainer>
            <StyledAampeSteps
                dividerType={'horizontal'}
                steps={steps || []}
                currentStepIndex={currentIndex}
                onClick={(index) => {
                    if (isNextStepClick) {
                        setCurrentIndex(index);
                    }
                }}
                showStepsAsCompleted={false}
            />

            <ContentContainer>
                {steps[currentIndex].renderComponent}
            </ContentContainer>
        </AampeStepperContainer>
    );
};

const AampeStepperContainer = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: aampeTheme.spacing4(6),
});

const StyledAampeSteps = styled(AampeSteps)({
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    gap: aampeTheme.spacing4(4),
    padding: aampeTheme.spacing4(0),
});

const ContentContainer = styled.div({
    width: '100%',
});
export default NotificationButtonForm;
